import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ROUTE_PATH } from "./constants/constants";

import { AuthGuard } from "./services/auth/auth.guard";
import { ROUTE_PATHS } from "./global/constants";
import { SuccessComponentComponent } from "./pages/shared/components/success-component/success-component.component";

const routes: Routes = [
  {
    path: ROUTE_PATH.ROOT,
    redirectTo: ROUTE_PATHS.DASHBOARD,
    pathMatch: "full",
  },
  {
    path: ROUTE_PATH.AUTHENTICATION.ABSOLUTE,
    loadChildren: () =>
      import("./pages/auth/auth.module").then((a) => a.AuthModule),
  },
  {
    path: ROUTE_PATH.ROUTES.ABSOLUTE,
    loadChildren: () =>
      import("./pages/merchant/merchant.module").then((s) => s.MerchantModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_PATH.ROUTES.CHECKOUTS,
    loadChildren: () =>
      import("./pages/merchant/checkouts/checkouts.module").then(
        (s) => s.CheckoutsModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./pages/merchant/add-money/add-money.module").then(
        (m) => m.AddMoneyModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./pages/merchant/settings/add-cards/add-cards.module").then(
        (m) => m.AddCardsModule,
      ),
    canActivate: [AuthGuard],
  },
  { path: ROUTE_PATHS.SUCCESS, component: SuccessComponentComponent },
  {
    path: "**",
    redirectTo: ROUTE_PATH.ROUTES.HOME,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), RouterModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
